import React from 'react';
import { Grid, GridItem } from 'ech-components/src/helpers';
import {
  ContactBox,
  TeaserNews,
  DigitIDAdaptForm,
  DigitIDRequestForm,
  DigitIDRegister,
} from 'ech-components/src/components';
import { IntlShape } from 'react-intl';
import { graphql, Script, StaticQuery } from 'gatsby';
import teaserNewsService from './teaserNewsService';
import useDigitIDQuery from '../queries/digitID/useDigitIDQuery';
import useDigitIDProvidersQuery from '../queries/digitID/useDigitIDProvidersQuery';

const customFrontendElementService = (
  data: {
    frontendElementName: string;
  },
  intl: IntlShape,
) => {
  const name = data?.frontendElementName;

  switch (name) {
    case 'Contactbox':
      return (
        <Grid columns={12}>
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <ContactBox
              withBurrito={false}
              header={intl.formatMessage({
                id: `teaser.faq.contact.ladestationinfrastruktur.title`,
              })}
              text={
                intl.formatMessage(
                  {
                    id: `teaser.faq.contact.ladestationinfrastruktur.text`,
                  },
                  {
                    br: <br />,
                  },
                ) as string
              }
              button1={{
                text: intl.formatMessage({
                  id: `teaser.faq.contact.ladestationinfrastruktur.mailText`,
                }),
                href: intl.formatMessage({
                  id: `teaser.faq.contact.ladestationinfrastruktur.mailLink`,
                }),
              }}
              button2={{
                text: intl.formatMessage({
                  id: `teaser.faq.contact.ladestationinfrastruktur.phone`,
                }),
                href: intl.formatMessage({
                  id: `teaser.faq.contact.ladestationinfrastruktur.phoneLink`,
                }),
              }}
              outerSpacing={false}
            />
          </GridItem>
        </Grid>
      );
    case 'News': {
      return (
        <StaticQuery
          query={graphql`
            query {
              allContentfulNewsHub(
                filter: { slug: { ne: null } }
                sort: { date: DESC }
              ) {
                nodes {
                  ...contentfulNewsFragment
                }
              }
            }
          `}
          render={({ allContentfulNewsHub }) => {
            const news = allContentfulNewsHub.nodes
              .filter(
                (item: { node_locale: string }) =>
                  item.node_locale === intl.locale,
              )
              .slice(0, 4);

            const teaserNewsProps = teaserNewsService(news, intl);

            return teaserNewsProps ? <TeaserNews {...teaserNewsProps} /> : null;
          }}
        />
      );
    }
    case 'Newsletter': {
      let formID;

      switch (intl.locale) {
        case 'fr':
          formID = 'pxJFLr';
          break;
        case 'it':
          formID = 'S8tpAT';
          break;
        default:
          formID = 'GcrsYI';
      }

      return (
        <Grid columns={12}>
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <Script>
              {`
                (function(w,d,e,u,f,l,n){w[f]=w[f]||function(){(w[f].q=w[f].q||[])
                .push(arguments);},l=d.createElement(e),l.async=1,l.src=u,
                n=d.getElementsByTagName(e)[0],n.parentNode.insertBefore(l,n);})
                (window,document,'script','https://assets.mailerlite.com/js/universal.js','ml');
                ml('account', '519671');
              `}
            </Script>
            <div className="ml-embedded" data-form={formID} />
          </GridItem>
        </Grid>
      );
    }
    case 'DigitIDAdapt': {
      const { privacyPolicyUrl, termsAndConditionsUrl } =
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDigitIDQuery(intl.locale);

      return (
        <Grid columns={12}>
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <DigitIDAdaptForm
              locale={intl.locale}
              apiUrl={
                process.env.GATSBY_CHARGING_STATION_ID_API_ADAPT_ID_URL || ''
              }
              privacyPolicyUrl={privacyPolicyUrl}
              termsAndConditionsUrl={termsAndConditionsUrl}
            />
          </GridItem>
        </Grid>
      );
    }
    case 'DigitIDRequest': {
      const { registerUrl, privacyPolicyUrl, termsAndConditionsUrl } =
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDigitIDQuery(intl.locale);

      return (
        <Grid columns={12}>
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <DigitIDRequestForm
              locale={intl.locale}
              apiUrl={
                process.env.GATSBY_CHARGING_STATION_ID_API_REQUEST_ID_URL || ''
              }
              registerUrl={registerUrl}
              privacyPolicyUrl={privacyPolicyUrl}
              termsAndConditionsUrl={termsAndConditionsUrl}
            />
          </GridItem>
        </Grid>
      );
    }
    case 'DigitIDRegister': {
      const providers =
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDigitIDProvidersQuery(intl.locale);

      return providers ? (
        <Grid columns={12}>
          <GridItem
            size={{ zero: 12, medium: 10, large: 8 }}
            push={{ zero: 0, medium: 1, large: 2 }}
          >
            <DigitIDRegister locale={intl.locale} providers={providers} />
          </GridItem>
        </Grid>
      ) : null;
    }
    default:
      return <></>;
  }
};

export default customFrontendElementService;
